import * as THREE from 'three';

/** Default fog fields for Environment panel / publish payload. */
export const FOG_DEFAULTS = {
  fog_checked: false,
  fogType: 'Linear',
  fogColor: '#ffffff',
  fogStart: 1,
  fogEnd: 100,
  fog_density: 0.01,
};

/**
 * Normalize fog settings from API / panel state into a consistent shape.
 */
export function normalizeFogSettings(source = {}) {
  const rawType = source.fogType || FOG_DEFAULTS.fogType;
  let fogType = 'Linear';
  if (
    rawType === 'Exponential' ||
    rawType === 'Exponential Squared' ||
    rawType === 'Exp2' ||
    rawType === 'FogExp2'
  ) {
    fogType = 'Exponential';
  } else if (rawType === 'Linear' || rawType === 'Fog') {
    fogType = 'Linear';
  }

  let fogColor = source.fogColor || FOG_DEFAULTS.fogColor;
  if (typeof fogColor === 'number') {
    fogColor = `#${fogColor.toString(16).padStart(6, '0')}`;
  } else if (typeof fogColor === 'string') {
    const trimmed = fogColor.trim();
    fogColor = trimmed
      ? trimmed.startsWith('#')
        ? trimmed
        : `#${trimmed}`
      : FOG_DEFAULTS.fogColor;
  } else {
    fogColor = FOG_DEFAULTS.fogColor;
  }

  const fogStart = Number(source.fogStart);
  const fogEnd = Number(source.fogEnd);
  const fogDensity = Number(source.fog_density);

  return {
    fog_checked: !!source.fog_checked,
    fogType,
    fogColor,
    fogStart: Number.isFinite(fogStart) ? fogStart : FOG_DEFAULTS.fogStart,
    fogEnd: Number.isFinite(fogEnd) ? fogEnd : FOG_DEFAULTS.fogEnd,
    fog_density: Number.isFinite(fogDensity)
      ? fogDensity
      : FOG_DEFAULTS.fog_density,
  };
}

export function applyFogToScene(scene, env) {
  try {
    scene.fog = null;

    if (!env || !env.fog_checked) {
      return;
    }

    const fog = normalizeFogSettings(env);
    let fogColor = 0xffffff;
    if (fog.fogColor) {
      if (typeof fog.fogColor === 'string') {
        const parsed = parseInt(fog.fogColor.replace('#', ''), 16);
        const isExplicitBlack =
          fog.fogColor.replace('#', '').toLowerCase() === '000000';
        fogColor =
          !isNaN(parsed) && (parsed !== 0 || isExplicitBlack)
            ? parsed
            : 0xffffff;
      } else if (typeof fog.fogColor === 'number') {
        fogColor = fog.fogColor;
      }
    }

    if (fog.fogType === 'Linear' || fog.fogType === 'Fog') {
      scene.fog = new THREE.Fog(fogColor, fog.fogStart, fog.fogEnd);
    } else if (
      fog.fogType === 'Exponential' ||
      fog.fogType === 'Exponential Squared' ||
      fog.fogType === 'Exp2' ||
      fog.fogType === 'FogExp2'
    ) {
      scene.fog = new THREE.FogExp2(fogColor, fog.fog_density);
    }
  } catch (error) {
    console.error('Error applying fog:', error);
  }
}
